import React from 'react';
import Job from '../types/job';
import useSortedCardcontent from '../../hooks/use-sorted-cardcontent';
import { CardContent, CardContentConfig } from '../../config/types/config';
import { objectEntries } from '../../utils/utils';

type Properties = {
  job: Job;
  cardContent?: CardContent<CardContentConfig>;
};

const JobPropertiesListSortable = ({ job, cardContent }: Properties) => {
  const { cardContentKeyToComponent, sortedCardContent } = useSortedCardcontent();

  return (
    <>
      {objectEntries(cardContent || sortedCardContent).map(([key]) => {
        const Component = cardContentKeyToComponent[key];
        return <Component job={job} key={key} />;
      })}
    </>
  );
};

export default JobPropertiesListSortable;
